// extracted by mini-css-extract-plugin
var _1 = "SectionTitle__SectionTitle___puEmv";
var _2 = "SectionTitle__container___yOWrR";
var _3 = "SectionTitle__size-large___t3zB5";
var _4 = "SectionTitle__size-medium___gmna5";
var _5 = "SectionTitle__size-medium-large___h6BmX";
var _6 = "SectionTitle__wiggle____Gf25";
export { _1 as "SectionTitle", _2 as "container", _3 as "size-large", _4 as "size-medium", _5 as "size-medium-large", _6 as "wiggle" }
